import { useState } from "react";
import { dashboardProducts, DashboardProduct } from "@/mocks/dashboardData";

const statusConfig = {
  active: { label: "Active", color: "bg-emerald-100 text-emerald-700" },
  pending: { label: "Pending Review", color: "bg-amber-100 text-amber-700" },
  paused: { label: "Paused", color: "bg-gray-100 text-gray-500" },
};

const ProductsTab = () => {
  const [products, setProducts] = useState<DashboardProduct[]>(dashboardProducts);
  const [search, setSearch] = useState("");

  const filtered = products.filter(
    (p) =>
      p.name.toLowerCase().includes(search.toLowerCase()) ||
      p.category.toLowerCase().includes(search.toLowerCase())
  );

  const toggleStatus = (id: string) => {
    setProducts((prev) =>
      prev.map((p) =>
        p.id === id
          ? { ...p, status: p.status === "active" ? "paused" : p.status === "paused" ? "active" : p.status }
          : p
      )
    );
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-5">
        <div className="relative flex-1 max-w-xs">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"></i>
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search products..."
            className="w-full pl-9 pr-4 py-2 border border-amber-100 rounded-xl text-sm focus:outline-none focus:border-amber-400 bg-white"
          />
        </div>
        <button className="flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-white font-semibold text-sm px-4 py-2 rounded-xl transition-colors cursor-pointer whitespace-nowrap">
          <i className="ri-add-line"></i> Add New Product
        </button>
      </div>

      <div className="space-y-3">
        {filtered.map((product) => {
          const sc = statusConfig[product.status];
          return (
            <div key={product.id} className="bg-white border border-amber-100 rounded-2xl p-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <div className="w-14 h-14 flex-shrink-0 rounded-xl overflow-hidden border border-amber-100">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover object-top" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-start gap-2 flex-wrap">
                  <p className="font-bold text-gray-900 text-sm">{product.name}</p>
                  <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${sc.color}`}>{sc.label}</span>
                </div>
                <p className="text-gray-400 text-xs mt-0.5">{product.category}</p>
                <div className="flex flex-wrap gap-4 mt-2 text-xs text-gray-500">
                  <span><i className="ri-test-tube-line text-amber-500 mr-1"></i>Sample: <strong className="text-gray-800">${product.samplePrice}</strong></span>
                  <span><i className="ri-stack-line text-emerald-500 mr-1"></i>Bulk: <strong className="text-gray-800">${product.bulkPrice}</strong></span>
                  <span>MOQ: <strong className="text-gray-800">{product.moq}</strong></span>
                  <span><i className="ri-eye-line text-gray-400 mr-1"></i>{product.views.toLocaleString()} views</span>
                  <span><i className="ri-shopping-bag-3-line text-gray-400 mr-1"></i>{product.orders} orders</span>
                </div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <button className="w-8 h-8 flex items-center justify-center border border-amber-100 rounded-lg text-amber-600 hover:bg-amber-50 cursor-pointer transition-colors">
                  <i className="ri-edit-line text-sm"></i>
                </button>
                {product.status !== "pending" && (
                  <button
                    onClick={() => toggleStatus(product.id)}
                    className={`w-8 h-8 flex items-center justify-center border rounded-lg cursor-pointer transition-colors ${
                      product.status === "active"
                        ? "border-gray-200 text-gray-400 hover:bg-gray-50"
                        : "border-emerald-200 text-emerald-600 hover:bg-emerald-50"
                    }`}
                  >
                    <i className={product.status === "active" ? "ri-pause-line text-sm" : "ri-play-line text-sm"}></i>
                  </button>
                )}
                <button className="w-8 h-8 flex items-center justify-center border border-red-100 rounded-lg text-red-400 hover:bg-red-50 cursor-pointer transition-colors">
                  <i className="ri-delete-bin-line text-sm"></i>
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductsTab;
